var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDisplay)?_c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({staticClass:"warning-box-icon"},on),[_vm._v("warning")])]}}],null,false,977391516)},[_c('span',{staticClass:"whitespace-pre"},[_vm._v(_vm._s(_vm.displayValidate(_vm.validationError)))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }